import { useState } from "react";
import { Logo } from "./Logo";
import { Menu, X } from "lucide-react";

export const Navbar = ({ t, lang, setLang }) => {
  const [open, setOpen] = useState(false);
  const links = [
    { href: "#craft", label: t.nav.craft },
    { href: "#heritage", label: t.nav.heritage },
    { href: "#commissions", label: t.nav.commissions },
    { href: "#works", label: t.nav.gallery },
  ];

  return (
    <header
      data-testid="main-nav"
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#F5F2EC]/85 border-b border-[#3E2723]/10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo-link" className="flex items-center gap-3">
          <Logo className="h-10 w-10" />
          <div className="leading-tight">
            <span className="font-serif text-xl font-bold text-[#3E2723] tracking-tight">LG</span>
            <span className="hidden sm:block text-[10px] uppercase tracking-[0.2em] text-[#A67C00] font-semibold">
              Italian Master Craftsman
            </span>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.slice(1)}`}
              className="text-sm font-medium text-[#3E2723]/80 hover:text-[#3E2723] transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <div data-testid="lang-toggle" className="flex items-center border border-[#3E2723]/20 rounded-sm overflow-hidden">
            {["en", "it"].map((l) => (
              <button
                key={l}
                data-testid={`lang-${l}-button`}
                onClick={() => setLang(l)}
                className={`px-3 py-1.5 text-xs font-semibold uppercase tracking-wider transition-colors duration-300 ${
                  lang === l ? "bg-[#3E2723] text-[#F5F2EC]" : "text-[#3E2723]/70 hover:bg-[#3E2723]/5"
                }`}
              >
                {l}
              </button>
            ))}
          </div>
          <a
            href="#quote"
            data-testid="nav-quote-button"
            className="hidden sm:inline-flex items-center bg-[#3E2723] text-[#F5F2EC] px-5 py-2.5 text-sm font-semibold rounded-sm hover:bg-[#2D1810] hover:-translate-y-0.5 transition-[transform,background-color] duration-300"
          >
            {t.nav.cta}
          </a>
          <button
            data-testid="mobile-menu-button"
            className="lg:hidden text-[#3E2723]"
            onClick={() => setOpen(!open)}
            aria-label="Menu"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-[#F5F2EC] border-t border-[#3E2723]/10 px-6 py-6 flex flex-col gap-4">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`mobile-nav-link-${l.href.slice(1)}`}
              onClick={() => setOpen(false)}
              className="text-base font-medium text-[#3E2723]"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#quote"
            data-testid="mobile-quote-button"
            onClick={() => setOpen(false)}
            className="inline-flex justify-center bg-[#3E2723] text-[#F5F2EC] px-5 py-3 text-sm font-semibold rounded-sm"
          >
            {t.nav.cta}
          </a>
        </div>
      )}
    </header>
  );
};
